import React, { useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { useViewport } from '../../hooks/useViewport';
import { useSelectedCategory, useMsId, useSetStoreName } from '../../store/appStore';
import { OneColumnLayout } from '../../components/layouts';
import { MobileStoreName } from './MobileStoreName/MobileStoreName';
import { StoreName } from './StoreName/StoreName';
import { useSuggestStoreName } from './api/mutations';
import { normalizeProducts } from './utils';
import { suggestionsAtom, resetStoreNameUIAtom } from './atoms';
import { usePaymentProviders } from './api/queries';
import { Box, Loader } from '@wix/design-system';
import { useSpec } from '../../hooks/useSpec';
import { SelectThemeFirst } from '../../experiments';
import { LoadingGridWrapper } from '../../components/ProductLoadingGrid/LoadingGridWrapper';
import { isProductsLoadingCompleteAtom } from '../templateSelection/atoms';

export function StoreNameWrapper() {
  const { isMobile } = useViewport();
  const msId = useMsId();
  const currentCategoryValue = useSelectedCategory();
  const setStoreName = useSetStoreName();
  const resetUI = useSetAtom(resetStoreNameUIAtom);
  const setSuggestions = useSetAtom(suggestionsAtom);
  const shouldSelectThemeFirst = useSpec(SelectThemeFirst);
  const isProductsLoadingComplete = useAtomValue(isProductsLoadingCompleteAtom);

  const { mutate: fetchSuggestions } = useSuggestStoreName();
  const { isLoading: isLoadingAggregators } = usePaymentProviders();

  useEffect(() => {
    const init = async () => {
      if (!msId || !currentCategoryValue) {
        return;
      }

      setStoreName('');
      fetchSuggestions(
        {
          category: currentCategoryValue,
          products: normalizeProducts(currentCategoryValue),
          previousResults: [],
        },
        {
          onSuccess: (data) => {
            setSuggestions(data);
          },
        },
      );
    };

    void init();

    return () => {
      resetUI();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msId]);

  if (!currentCategoryValue) {
    return;
  }

  if (shouldSelectThemeFirst && (!msId || !isProductsLoadingComplete)) {
    return <LoadingGridWrapper category={currentCategoryValue} />;
  }

  if (isLoadingAggregators) {
    return (
      <Box align="center" verticalAlign="middle" height="100%" width="100%">
        <Loader size="large" />
      </Box>
    );
  }

  if (isMobile) {
    return <OneColumnLayout content={<MobileStoreName />} />;
  }

  return <StoreName />;
}
